import React from "react";
import {Col, FormGroup, Input, Label, CustomInput, FormFeedback} from "reactstrap";

const FileInput = ({id, name, description, placeholder, onUploadChange, value, onChange, required, errors }) => {
    return (
        <FormGroup row className="mb-2">
            <Label md={4} className="pr-md-1">
                {description} {!!required && '*'}
            </Label>
            <Col md={8}>
                <CustomInput
                    type="file"
                    id={`newFile-${name}`}
                    name={name}
                    onChange={e => {
                        onChange(id, {
                            [e.target.name]: e.target.files.length ? e.target.files[0]?.name : null
                        });
                         onUploadChange(id, e.target.files[0] || null)
                    }}
                    label={placeholder || description}
                />
                {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
            </Col>
        </FormGroup>
    );
};
export default FileInput;
